export default {
  title: 'Applicant Status Auto Change Management',
  menu: 'Applicant Status Auto Change Management',
  label: {
    status: 'Applicant Status',
    statusDwellTime: 'After(days)',
    autoChangeTo: 'Automatically Change Status To',
    hasConfig: {
      has: 'Configured',
      not: 'Not Configured'
    }
  },
  placeholder: {
    dwellTime: 'Please enter days',
    autoChangeTo: 'Please select'
  },
  btn: {
    deleteConfig: 'Delete',
    saveConfig: 'Save',
    addConfig: 'Add'
  },
  message: {
    deleteSuccess: 'Delete Success',
    cannotSaveEmpty: 'Please configure at least one rule',
    dwellTimeIsNotInt: 'Please input an integer greater than 0',
    remindConfigRuleTip: 'When the lock time is 5 days, it needs to be configured as 2 + 2 + 1 if it needs to be reminded on the second day, the fourth day and the fifth day\nWhen infinity locked, it needs to be reminded once every 5 days, then the configuration is 5',
    confirmDelete: 'Are you sure to delete this configuration?'
  }
}
